import { render, staticRenderFns } from "./LabelEdition.vue?vue&type=template&id=fb2ee228&"
import script from "./LabelEdition.vue?vue&type=script&lang=js&"
export * from "./LabelEdition.vue?vue&type=script&lang=js&"
import style0 from "./LabelEdition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports